import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-en-construccion',
  templateUrl: './en-construccion.component.html',
  styleUrls: ['./en-construccion.component.scss']
})
export class EnConstruccionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
